import { IAppState } from '../../core/redux/IAppState';
import * as R from 'ramda';


/**
 * Gets the successful import guest for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getImportGuestSuccess = (
  state: IAppState,
  guestId: string | undefined,
): boolean => !!R.find(id => id === guestId && !!id, state.importSuccesses);
